import script from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchBar.vue?vue&type=script&lang=ts&setup=true"

import "./SearchBar.vue?vue&type=style&index=0&id=0c621bc6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c621bc6"]])

export default __exports__